import { interWbHttp } from '@interco/inter-webview-bridge'

import { SurveyParams, SurveyResultApiResponse, SurveyType } from './types'

const BASE = 'app-pf/international-account/fake-door/v1/surveys'

export const getSurveyResult = async (
  surveyType: SurveyType,
  accountNumber: string,
): Promise<SurveyResultApiResponse | null> => {
  const endpoint = `${BASE}/${surveyType}/accounts/${accountNumber}`

  const { response } = await interWbHttp.get({
    endpoint,
    headers: {},
    options: {},
  })

  if (!response) {
    return null
  }

  return JSON.parse(response) as SurveyResultApiResponse
}

export const submitSurveyResult = async ({
  surveyType,
  accountNumber,
}: SurveyParams): Promise<SurveyResultApiResponse> => {
  const endpoint = `${BASE}/${surveyType}/accounts/${accountNumber}/complete`

  const headers = {
    'Content-Type': 'application/json',
  }

  const { response } = await interWbHttp.post({
    endpoint,
    body: {},
    headers,
    options: {},
  })

  return JSON.parse(response) as SurveyResultApiResponse
}
